export default {"src":"/_next/static/media/blue-cat.a55af2e9.svg","height":89,"width":82,"blurWidth":0,"blurHeight":0};